'use strict';

import { Auth } from 'aws-amplify';
import axios from 'axios';
import { endpoint, API_BASE_URL, COMPANY_API_ENDPOINTS } from '@/utils/endpoints';

export const store = {
	state: {
		username: null,
		tenant: 'LBMAIN',
		HFWTexts: [
			'I have a referral code',
			'I am a SAMA member',
			'Alpha Pharm Pharmacy',
			'SAVA Member',
			'Vetmaster',
			'Facebook',
			'Instagram',
			'LinkedIn',
			'Twitter',
			'Google Search',
			'Direct Email',
			'Word of Mouth',
			'Other',
		],
		HFWValues: [
			'referralCode',
			'samaMember',
			'Alpha Pharm Pharmacy',
			'SAVAmember',
			'Vetmaster',
			'Facebook',
			'Instagram',
			'LinkedIn',
			'Twitter',
			'Google Search',
			'Direct Email',
			'Word of Mouth',
			'other',
		],
		HFWTextLabels: {
			referralCode: 'Enter referral code',
			samaMember: 'Enter SAMA membership number',
			other: "Enter text for 'Other'",
			SAVAmember: 'Enter SAVA membership number',
		},
		industry: ['Pharmacy', 'Nursing', 'General Medical', 'Dental', 'Optometry', 'Radiology', 'Veterinary', 'Other'],
	},

	mutations: {
		SET_USERNAME(state, payload) {
			state.username = payload;
		},
		SET_TENANT(state, payload) {
			state.tenant = payload;
		},
	},

	getters: {
		getUsername(state) {
			return state.username;
		},

		getTenant(state) {
			return state.tenant;
		},

		heardFromWhereOptions(state) {
			return state.HFWTexts.map((text, index) => ({
				text,
				value: state.HFWValues[index],
			}));
		},
	},

	actions: {
		async SignIn(_, { email, password }) {
			email = email.toLowerCase().trim();

			try {
				const result = await Auth.signIn(email, password);

				if (result.challengeName === 'NEW_PASSWORD_REQUIRED') {
					return {
						success: false,
						failureType: 'CHALLANGE',
						failureValue: 'NEW_PASSWORD_REQUIRED',
					};
				} else {
					return {
						success: true,
						user: result,
					};
				}
			} catch (error) {
				if (['UserNotConfirmedException', 'PasswordResetRequiredException'].includes(error.code)) {
					return {
						success: false,
						failureType: 'ERROR',
						failureValue: error.code,
					};
				} else {
					return {
						success: false,
						failureType: 'ERROR',
						failureValue: 'Unknown',
					};
				}
			}
		},

		async SignUp(_, { username, password, attributes }) {
			username = username.toLowerCase().trim();

			try {
				const result = await Auth.signUp({ username, password, attributes });

				return {
					success: true,
					user: result,
				};
			} catch (error) {
				if (['UserNotConfirmedException', 'PasswordResetRequiredException'].includes(error.code)) {
					return {
						success: false,
						failureType: 'ERROR',
						failureValue: error.code,
					};
				} else {
					return {
						success: false,
						failureType: 'ERROR',
						failureValue: 'Unknown',
					};
				}
			}
		},

		async AddToGroup(_, { username, groupName }) {
			const url = endpoint(API_BASE_URL, 'users/cognito/addtogroup');
			await axios.post(url, {
				username,
				groupname: groupName,
			});
		},

		async CompleteNewPassword(_, { user, password }) {
			const result = await Auth.completeNewPassword(user, password);
			return result;
		},

		async AcceptCompanyInvite(_, { user, token }) {
			if (!token) throw new Error('Missing Arguments');

			const jwtToken = user.getSignInUserSession().getIdToken().jwtToken;
			if (!jwtToken) throw new Error('Missing Arguments');

			const url = endpoint(API_BASE_URL, COMPANY_API_ENDPOINTS.ACCEPT_INVITE);
			await axios.post(url, { token }, { headers: { Authorization: jwtToken } });
		},
	},
};

export default store;
